enum MainAttributeGroups {
  USER_INTERFACE = "UserInterface",
  SYSTEM = "System",
}
export default MainAttributeGroups;
